import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { TipService } from '../../../service/tip/tip.service';
import { Tip } from '../../../class/tip';

@Component({
  selector: 'app-tip',
  templateUrl: './tip.component.html',
  styleUrls: ['./tip.component.scss']
})
export class TipComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoTip: Tip;
    public tip: Tip;
    public msgs: Message[] = [];
    public options: any;
    public latitude: number;
    public longitude: number;
    public zoom: number;
    public overlays: any[];

    constructor(
        public tipService: TipService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    private setPosition(position) {
        this.latitude = position.lat;
        this.longitude = position.lng;
        this.zoom = 17;
    }

    public addMarker(lat, lng, title) {
        this.longitude = lng;
        this.latitude = lat;
        this.overlays = [];
        this.overlays.push(
            new google.maps.Marker({
                position: {
                    lat: lat,
                    lng: lng
                }, title: title}
            )
        );
    }

    public cancelTip () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/tips/tip/tip.component.ts